export default __webpack_public_path__ + "static/3PARKINGCAR-bd629d9b0f392c10dd223d4302d4ac65.png";